// extracted by mini-css-extract-plugin
export default {"Segment":"SegmentSpacer_Segment__Mrprt","SegmentTitle":"SegmentSpacer_SegmentTitle__W0zLw"};